import _ from 'lodash';
import { getPartnerRefer } from '@/views/config/partner-refer/helper/utils';
import { isEmptyVal } from '@/utils';
import { pageConfig } from '@/common/service/page-config';
import { getPlanTypeByCategory } from '@/common/service/parse';
import { addToCart, addToCartByCategoryAndBillingCycle } from '@/common/service/flow/utils';
import {
  getCurrentEditPlanQuantity,
  loadDefaultPlansByPreload4MixBuy,
  loadDefaultPlansByPreloadForEdit,
} from '@/views/config/coupon/helper/preload';
import { isZoneBundleContext } from '@/plans/ZOOM_MEETING/common/utils';

const preloadPlanFromReferralInfo = (planList = [], preloadPlanCodeList = [], defaultLicense = 1) => {
  return _.map(planList, (item) => {
    const planCode = item.plan_code;

    if (_.includes(preloadPlanCodeList, planCode) ) {
      return addToCart(item, defaultLicense);
    }

    return item;
  });
};

// just for buy now/free upgrade case
export const loadDefaultPlansByPartnerReferral = (planList) => {
  const partnerRefer = getPartnerRefer();

  // if the purchase not from partner refer
  if (isEmptyVal(partnerRefer) || !isEmptyVal(pageConfig.partnerReferralErrorResult)) {
    return planList;
  }

  const haveSelectedPlan = _.some(planList, (p) => p.cartInfo?.selected_number);

  // have selected plan for other preload case
  if (haveSelectedPlan) return planList;

  const { plan, period } = pageConfig;
  const planType = getPlanTypeByCategory(plan);

  // should exclude pro+/biz+ bundle plan with query, need preload with default query
  if (isZoneBundleContext) {
    return planList;
  }

  // preload plan through specified url and parameters
  if (!isEmptyVal(planType) && !isEmptyVal(period)) {
    addToCartByCategoryAndBillingCycle(planList, planType, plan, period);
    return planList;
  }

  // preload plans with pre config in op management
  return preloadPlanFromReferralInfo(planList, partnerRefer.preloadPlan);
};

export const loadDefaultPlansByPartnerReferral4MixBuy = (boughtPlans) => {
  const partnerRefer = pageConfig?.partnerReferral;

  if (isEmptyVal(partnerRefer?.coupon)) {
    return (planList) => planList;
  }

  // MIX_BUY
  return loadDefaultPlansByPreload4MixBuy(boughtPlans, partnerRefer?.coupon);
};

export const loadDefaultPlansByPartnerReferralForEdit = (boughtPlans) => {
  const partnerRefer = pageConfig?.partnerReferral;
  const marketingCoupon = partnerRefer?.coupon;
  const preloadPlans = partnerRefer?.preloadPlan;

  return (planList) => {
    const haveSelectedPlan = _.find(planList, (p) => p.cartInfo?.selected_number);

    if (haveSelectedPlan) return planList;

    // preload planList by marketing coupon (partner jointsale mode) priority is highest
    if (!isEmptyVal(marketingCoupon)) {
      return loadDefaultPlansByPreloadForEdit(planList, boughtPlans, marketingCoupon);
    }

    // preload planList by partner refer (partner referral mode)
    if (!isEmptyVal(preloadPlans)) {
      const editSelectedNumber = getCurrentEditPlanQuantity(boughtPlans);

      return preloadPlanFromReferralInfo(planList, preloadPlans, editSelectedNumber);
    }

    return planList;
  }
};
